import { Size } from 'app/interfaces/Image';

export default function getScreenPixelSpacingFromDimensions(dimensions: Size) {
  const { width: screenWidth, height: screenHeight, orientation } = window.screen;
  const isRotated = orientation.angle % 180 !== 0;
  const realScreenWidth = isRotated ? screenHeight : screenWidth;
  const realScreenHeight = isRotated ? screenWidth : screenHeight;

  const { width, height } = dimensions ?? {};
  if (!width || !height) return;

  const screenPixelSpacing = {
    rowPixelSpacing: dimensions.height / realScreenHeight,
    columnPixelSpacing: dimensions.width / realScreenWidth,
  };
  return screenPixelSpacing;
}
